<template>
  <b-card no-body class="position-relative overflow-hidden">
    <div :class="['position-absolute top-0 left-0 w-100 h-100', gradientCard.color]"></div>

    <b-card-body  class="zindex-1 d-flex flex-column justify-content-between">
      <div>
      <div class="d-flex align-items-center text-white pb-2">
        <feather-icon :icon="gradientCard.icon" class="mr-50"/> 
        <small>{{gradientCard.title}}</small>
      </div>
       <slot />
      <div class="pb-2" v-if="gradientCard.content"> 
        <small>{{gradientCard.content}}</small>
      </div>
       <slot name="bottom" />
      </div>
      <div v-if="gradientCard.buttonLabel"> 
        <router-link tag="button" class="btn bg-transparent shadow-lg text-white"  :to="{ name: gradientCard.url }">
          {{ gradientCard.buttonLabel }}</router-link>
      </div>
    </b-card-body>
  </b-card>

</template>

<script>
import {BCard, BCardBody , BButton  } from "bootstrap-vue";

export default {
  components: {
    BCard, BCardBody,BButton
  },
  props:{
    gradientCard:{
      type:Object,
      default:()=>{}
    }  
  
  }
}
</script>
